<template>
  <div class="tips">
    <p>1. 认证审核：教师基本资料和个人资质需要审核；</p>
    <p>2. 认证审核：只有审核通过后才能发布课程；</p>
    <p>3. VIP：未开通VIP情况下，教师发布的服务，每日限制发布服务次数为1次，VIP用户发布服务次数无限制；</p>
  </div>
</template>

<script>
export default {
  name: 'MiuDesc'
}
</script>

<style scoped>
.tips {
  padding: 4px 19px;
  background-color: #f5f5f5;
  border-radius: 10px;
  color: #727272;
  line-height: 10px;
}

</style>